/**
 * 完整变体响应转录入 DTO；只列可写字段，禁止把派生金额或核验状态发回 API。
 * 无 Stripe 映射的变体保持同空：原值下架可直接提交，其余写入须补齐 Product / Price。
 */
import type {
  WebPaymentProductVariantResponse,
  WebProductVariantRequest,
} from '@novel-admin/shared';

export function webVariantRequest(row: WebPaymentProductVariantResponse): WebProductVariantRequest {
  return {
    vendor_product_id: row.vendor_product_id,
    stripe_price_id: row.stripe_price_id,
    subscription_period: row.subscription_period,
    coin_amount: row.coin_amount,
    bonus_amount: row.bonus_amount,
    daily_grant_amount: '0',
    original_amount_minor_units: row.original_amount_minor_units,
    sort_order: row.sort_order,
    is_active: row.is_active,
  };
}
export const WEB_VERIFICATION_LABELS = {
  VERIFIED: 'Stripe 已核验',
  NOT_CHECKED: '本次未核验，请刷新',
  NOT_APPLICABLE: '无 Stripe 映射，仅经框架通道售卖',
  CONFIG_CHANGED: '配置已变化，请重新核验',
  BUDGET_EXHAUSTED: '核验预算耗尽，请缩小分页',
  DEADLINE_EXCEEDED: '核验截止，请分批重读',
  CONFIG_UNAVAILABLE: 'Stripe 配置未就绪',
  MISMATCH: 'Product / Price 不匹配',
  UPSTREAM_UNAVAILABLE: 'Stripe 暂不可达',
} as const;
